var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-avatar', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "tile": "",
      "color": "grey lighten-4"
    }
  }, [_vm.hasAvatar ? _c('v-img', {
    attrs: {
      "src": _vm.expert.avatar.url,
      "alt": "".concat(_vm.expert.companyName, " \uB85C\uACE0"),
      "contain": ""
    }
  }) : _c('v-icon', {
    attrs: {
      "size": "4rem"
    }
  }, [_vm._v("mdi-domain")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }